import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20fashion%20and%20lifestyle%20product%20collage%20on%20rich%20terracotta%20and%20sand%20colored%20abstract%20background%2C%20sneakers%20hoodies%20bags%20and%20accessories%20scattered%20artistically%2C%20warm%20golden%20hour%20lighting%20with%20dramatic%20shadows%2C%20editorial%20creative%20photography%2C%20vibrant%20composition%20with%20negative%20space%20in%20upper%20area%20for%20text%20overlay%2C%20modern%20bold%20aesthetic%20with%20mixed%20textures%20and%20materials&width=1920&height=1080&seq=hero-bg-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet Polska"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/10 via-white/5 to-background-50/80"></div>
      </div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 max-w-4xl mx-auto">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-tight mb-6">
          {t('hero.title')}
        </h1>
        <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto mb-8 leading-relaxed">
          {t('hero.subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 text-base font-semibold px-8 py-3.5 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            {t('hero.ctaPrimary')}
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-background-50/90 text-foreground-900 text-base font-medium px-8 py-3.5 rounded-full hover:bg-background-50 transition-all border border-background-200/70 whitespace-nowrap cursor-pointer"
          >
            {t('hero.buyNow')}
            <i className="ri-shopping-bag-line text-lg"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-500"></i>
            {t('hero.trust1')}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-500"></i>
            {t('hero.trust2')}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-500"></i>
            {t('hero.trust3')}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-500"></i>
            {t('hero.trust4')}
          </span>
        </div>
      </div>
    </section>
  );
}